import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';
import { BudgetDetails } from 'src/app/shared/models/detalle-presupuesto';
import { BudgetItem } from 'src/app/shared/models/partida-presupuesto';
import { MaterialesPresupuestoComponent } from '../materiales-presupuesto/materiales-presupuesto.component';
import { EquiposPresupuestoComponent } from '../equipos-presupuesto/equipos-presupuesto.component';
import { ManoDeObraPresupuestoComponent } from '../mano-de-obra-presupuesto/mano-de-obra-presupuesto.component';
import { DatosGeneralesPresupuestoComponent } from '../datos-generales-presupuesto/datos-generales-presupuesto.component';
import { CondicionesApuComponent } from '../condiciones-apu/condiciones-apu.component';
import { MatSort } from '@angular/material/sort';
import { CapitulosPresupuestoComponent } from '../capitulos-presupuesto/capitulos-presupuesto.component';
import { Constanst } from 'src/app/core/constants/constans.component';
import { CapturarPartidasPresupuestoComponent } from '../capturar-partidas-presupuesto/capturar-partidas-presupuesto.component';
import { VerApuPresupuestoComponent } from '../ver-apu-presupuesto/ver-apu-presupuesto.component';
import { ModificarPartidaPresupuestoComponent } from '../modificar-partida-presupuesto/modificar-partida-presupuesto.component';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { CachePartidasService } from 'src/app/core/services/cache-partidas-service';
import { Subject, lastValueFrom, takeUntil } from 'rxjs';
import { ExportExcelService } from 'src/app/core/services/exportar-excel.service';
import * as pdfMake from 'pdfmake/build/pdfmake';
import { DatePipe, DecimalPipe, registerLocaleData } from '@angular/common';
import { BudgetLineItemQuantities } from 'src/app/shared/models/budget-item-quantities';

import es from '@angular/common/locales/es';
import { BudgetSignatures } from 'src/app/shared/models/firmas-presupuesto';

@Component({
  selector: 'app-detalle-presupuesto',
  templateUrl: './detalle-presupuesto.component.html',
  styleUrls: ['./detalle-presupuesto.component.css'],
  providers: [DecimalPipe, DatePipe]
})
export class DetallePresupuestoComponent implements AfterViewInit {

  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  displayedColumns: string[] = ['position', 'chapterReference', 'reference', 'code', 'unit', 'quantity', 'unitPrice', 'assumedPrice', 'total', 'performance'];
  filterDetails = new FormControl('0');
  descriptionFilter = new FormControl({ value: '', disabled: true });
  descriptionSearch = new FormControl({ value: '', disabled: false });
  filterValue: string;
  filterNoSelected: boolean = false;
  filterDictionary = new Map<string | null, string | null>();
  dataSource = new MatTableDataSource<BudgetItem>;
  dataSourceFilters = new MatTableDataSource<BudgetItem>;
  messageError: string;
  infoPresupuesto: BudgetDetails;
  descripcionPartida: string = '';
  partidaSeleccionada: string;
  partidaActual: number = 0;
  totalPartidas: number = 0;

  rowCursor = -1;
  selectedRowIds: Set<number> = new Set<number>();
  listReferencePartidas: string[] = [];
  listPartidas: BudgetItem[] = [];

  budgetTotalIva: number = 0;
  budgetGrandTotal: number = 0;
  budgetlIva: number = 0;
  budgeTotal: number = 0;
  budgetOtherTax: number = 0;
  budgetTotalOtherTax: number = 0;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('autosize') autosize: CdkTextareaAutosize;

  displayedColumnsMaterial: string[] = ['reference', 'description', 'unit', 'quantity', 'waste', 'price', 'total'];
  displayedColumnsEquipos: string[] = ['reference', 'description', 'quantity', 'waste', 'price', 'total'];
  displayedColumnsManoObras: string[] = ['reference', 'description', 'quantity', 'jornal', 'bono', 'totaljornal', 'totalbono'];
  xpandStatus = false;
  xpandDisabled = true;
  dataSourceMaterial = new MatTableDataSource<any>;
  dataSourceEquipo = new MatTableDataSource<any>;
  dataSourceManosObra = new MatTableDataSource<any>;
  totalMateriales: number;
  totalEquipos: number;
  totalManoDeObra: number;
  totalBonoManoDeObra: number;
  apuConditionId: number;
  rendimiento: number;
  workingHour: number;
  porcFinanciamiento: number;
  porcGastosAdministrativos: number;
  porcImpuestoIva: number;
  porcOtrosImpuestos: number;
  porcUtilidadesImprevisto: number;
  porcPrestacionesManoDeObra: number;
  costoUnicoMateriales: number;
  costoUnicoEquipo: number;
  prestManoDeObra: number;
  totalGeneralManoDeObra: number;
  costoUnicoManoDeObra: number;
  costoDirectoSubTotalA: number;
  gastosGeneralesAdmin: number;
  subTotalB: number;
  utilidadesImprevisto: number;
  subTotalC: number;
  financiamiento: number;
  precioUnitarioSinImpuesto: number;
  montoImpuestoIva: number;
  montoOtrosImpuestos: number;
  precioUnitario: number = 0;
  porcIncidenciasMateriales: number;
  porcIncidenciasEquipos: number;
  porcIncidenciasManoDeObra: number;
  totalTrabajadores: number;
  workingHourDay: number;
  referenciaPartida: string = "(clic en tabla)";
  descripcionPartidaPanel: string = '';
  disableExcel: boolean = false;
  classFlag: boolean = false;
  budgetName: string = '';

  constructor(
    private router: Router,
    private apiCallService: ApiCallService,
    private helperClassService: HelperClassService,
    private cachePartidasService: CachePartidasService,
    private exportExcelService: ExportExcelService,
    private decimalPipe: DecimalPipe,
    private datePipe: DatePipe,
    public dialogInsumosMateriales: MatDialog,
    public dialogInsumosEquipos: MatDialog,
    public dialogInsumosManoObra: MatDialog,
    public dialogDatosPresupuesto: MatDialog,
    public dialogCondicionesApu: MatDialog,
    public dialogCapitulos: MatDialog,
    public dialogCapturarPartidas: MatDialog,
    public dialogVerPartidas: MatDialog,
    public dialogModificarPartida: MatDialog
  ) {
    this.descripcionPartida = '';
    this.partidaSeleccionada = '';
    this.partidaActual = 0;
    this.totalPartidas = 0;
  }

  async ngOnInit() {
    registerLocaleData(es);
    this.classFlag = this.helperClassService.validateViewMobileScreen(screen.width);
    //Inicio - Colocar valor por defecto 
    this.filterDetails.setValue('description');
    this.cleanFilter();
    //Fin - Colocar valor por defecto 
    let data: any = this.helperClassService.getData();
    if (data === undefined) {
      await this.reloadBudgetDetail();
    } else {
      this.infoPresupuesto = data;
      this.budgetName = this.infoPresupuesto.budgetName;
    }

    this.cachePartidasService.getOnBudgetById(Constanst.CACHE_NAME_BUDGET_IVA).subscribe((budgetIva: any) => {
      this.budgetlIva = budgetIva;
    });
    this.cachePartidasService.getOnBudgetById(Constanst.CACHE_NAME_BUDGET_OTHERTAX).subscribe((otherTaxBudget: any) => {
      this.budgetOtherTax = otherTaxBudget;
    });

    this.helperClassService.notifierNewChangeBudget.subscribe(changedData => {
      if (changedData == Constanst.CACHE_NAME_BUDGET_IVA) {
        this.cachePartidasService.getOnBudgetById(Constanst.CACHE_NAME_BUDGET_IVA).subscribe((ivaBudget: any) => {
          this.budgetlIva = ivaBudget;
        });
        this.cachePartidasService.getOnBudgetById(Constanst.CACHE_NAME_BUDGET_OTHERTAX).subscribe((otherTaxBudget: any) => {
          this.budgetOtherTax = otherTaxBudget;
        });
      } else if (changedData == Constanst.APLICAR_IVA_PRESUPUESTO || changedData == Constanst.APLICAR_IVA_APU || changedData == Constanst.APLICAR_IVA_NINGUNO) {
        this.infoPresupuesto.applyIva = changedData;
        this.cachePartidasService.getAll().subscribe((data: BudgetItem[]) => {
          this.dataSourceFilters.data = data;
        });
        this.processBudgetTotals();
      } else if (changedData == 'apuCondition') {
        this.cachePartidasService.getAll().subscribe((data: BudgetItem[]) => {
          this.dataSourceFilters.data = data;
        });
        this.processBudgetTotals();
      } else if (changedData == 'budgetName') {
        this.budgetName = this.infoPresupuesto.budgetName.toUpperCase();
      } else {
        this.processBudgetTotals();
      }
    });

    this.cachePartidasService.getAll().subscribe((data: BudgetItem[]) => {
      this.dataSourceFilters.data = data;
      this.processBudgetTotals();
    });

    this.helperClassService.notifierNewChangeBudget.subscribe(processedExcel => {
      this.disableExcel = false;
      this.apiCallService.hideSpinner();
    });


    this.dataSourceFilters.filterPredicate = function (record, filter) {
      var map = new Map(JSON.parse(filter));
      let isMatch = false;
      for (let [key, value] of map) {
        if (key as keyof BudgetItem === 'description') {
          isMatch = (record.description || '').trim().toLowerCase().indexOf(value as keyof BudgetItem) !== -1;
        } else if (key as keyof BudgetItem === 'reference') {
          isMatch = (record.reference || '').trim().toLowerCase().indexOf(value as keyof BudgetItem) !== -1;
        } else if (key === "0") {
          isMatch = (record.reference || '').trim().toLowerCase().indexOf(value as keyof BudgetItem) !== -1
            || (record.description || '').trim().toLowerCase().indexOf(value as keyof BudgetItem) !== -1
            || (record.unit || '').trim().toLowerCase().indexOf(value as keyof BudgetItem) !== -1
            || String(record.unitPrice).toString().indexOf(value as keyof BudgetItem) !== -1
            || String(record.performance).toString().indexOf(value as keyof BudgetItem) !== -1
            || (record.chapterReference || '').trim().toLowerCase().indexOf(value as keyof BudgetItem) !== -1
            || (record.code || '').trim().toLowerCase().indexOf(value as keyof BudgetItem) !== -1
        } else if (value === '') {
          isMatch = true;
        };
        if (!isMatch) return false;
      }
      return isMatch;
    };
  }

  processBudgetTotals() {
    this.totalPartidas = this.dataSourceFilters.data.length;
    if (this.totalPartidas > 0) {
      this.budgeTotal = this.dataSourceFilters.data.map((t: { total: any; }) => t.total).reduce((acc: number, value: number) => acc + value, 0);
      this.budgetTotalIva = (this.infoPresupuesto.applyIva == Constanst.APLICAR_IVA_PRESUPUESTO ? (this.budgeTotal * (this.budgetlIva / 100)) : 0);
      this.budgetTotalOtherTax = (this.infoPresupuesto.applyIva == Constanst.APLICAR_IVA_PRESUPUESTO ? (this.budgeTotal * (this.budgetOtherTax / 100)) : 0);
      this.budgetGrandTotal = (this.budgeTotal + this.budgetTotalIva + this.budgetTotalOtherTax);
    } else {
      this.budgeTotal = 0;
      this.budgetTotalIva = 0;
      this.budgetTotalOtherTax = 0;
      this.budgetGrandTotal = 0;
    }
  }

  ngAfterViewInit() {
    this.dataSourceFilters.sort = this.sort;
  }

  cleanFilter() {
    this.xpandStatus = false;
    this.descriptionFilter.setValue('');
    this.descriptionSearch.setValue('');
    if (this.filterDetails.value === '0') {
      this.descriptionFilter.disable();
      this.descriptionSearch.enable();
    } else {
      this.descriptionFilter.enable();
      this.descriptionSearch.disable();
    }
  }

  applyFilterDetails(event: Event) {
    this.xpandStatus = false;
    this.filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (this.filterDetails.value === '0' && this.filterValue === '') {
      this.filterNoSelected = true;
    } else {
      this.filterNoSelected = false;
    }

    this.filterDictionary.set(this.filterDetails.value, this.filterValue);
    var jsonString = JSON.stringify(Array.from(this.filterDictionary.entries()));
    this.dataSourceFilters.filter = jsonString;

  }

  verDescripcionPartida(rowId: number) {
    for (let i = 0; i < this.dataSourceFilters.data.length; i++) {
      let partida = this.dataSourceFilters.data[i];
      if (partida.position == rowId) {
        this.descripcionPartida = partida.description;
        this.partidaActual = i + 1;
        break;
      }
    }
  }

  verMaterialesPresupuesto() {
    if (this.dataSourceFilters.data.length > 0) {
      this.dialogInsumosMateriales.open(MaterialesPresupuestoComponent, { width: '100%', maxWidth: '100%', height: '100%', data: this.infoPresupuesto.budgetId });
    } else {
      this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_EMPTY_BUDGET, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
    }
  }

  verEquiposPresupuesto() {
    if (this.dataSourceFilters.data.length > 0) {
      this.dialogInsumosEquipos.open(EquiposPresupuestoComponent, { width: '100%', maxWidth: '100%', height: '100%', data: this.infoPresupuesto.budgetId });
    } else {
      this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_EMPTY_BUDGET, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
    }
  }

  verManoDeObraPresupuesto() {
    if (this.dataSourceFilters.data.length > 0) {
      this.dialogInsumosEquipos.open(ManoDeObraPresupuestoComponent, { width: '100%', maxWidth: '100%', height: '100%', data: this.infoPresupuesto.budgetId });
    } else {
      this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_EMPTY_BUDGET, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
    }
  }

  verDatosGeneralesPresupuesto() {
    this.helperClassService.setData(this.infoPresupuesto);
    this.dialogDatosPresupuesto.open(DatosGeneralesPresupuestoComponent, { width: '100%', maxWidth: '100%', height: '100%', data: this.infoPresupuesto.budgetId });
  }

  verCondicionesApuPresupuesto() {
    if (this.getSelectedRows().length > 0) {
      this.helperClassService.setData(this.infoPresupuesto);
      this.dialogCondicionesApu.open(CondicionesApuComponent, { width: '50rem', data: this.getSelectedRows()[0] });
    } else {
      this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_LINEITEM_EMPTY, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
    }
  }

  verCapitulosApuPresupuesto() {
    if (this.getSelectedRows().length > 0) {
      this.getListReferencePartidas(this.getSelectedRows());
      this.dialogCapitulos.open(CapitulosPresupuestoComponent, { width: '100%', maxWidth: '100%', height: '100%', data: this.listReferencePartidas });
    } else {
      this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_LINEITEM_EMPTY, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
    }
  }

  capturarPartidasPresupuesto() {
    this.dialogCapturarPartidas.open(CapturarPartidasPresupuestoComponent, { width: '100%', maxWidth: '100%', height: '100%', data: this.infoPresupuesto.budgetId });
  }

  VerPartidasPresupuesto() {
    if (this.getSelectedRows().length > 0) {
      this.listPartidas = this.getSelectedRows();
      this.helperClassService.setData(this.infoPresupuesto);
      this.dialogVerPartidas.open(VerApuPresupuestoComponent, { width: '100%', maxWidth: '100%', height: '100%', data: this.listPartidas[0] });
    } else {
      this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_LINEITEM_EMPTY, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
    }
  }

  navigateHomePresupuesto() {
    let dialogSalirPresupuesto = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_CONFIRM_EXIT_BUDGET, true, true, false, Constanst.DIALOG_ACTIONBTCANCEL, Constanst.DIALOG_ACTIONBTACCEPT, '', Constanst.DIALOG_RESULT_INFO);
    dialogSalirPresupuesto.afterClosed().subscribe((result: string) => {
      if (result === Constanst.DIALOG_RESULT_ACTION) {
        this.cachePartidasService.clear();
        this.router.navigate(['presupuestos']);
      } else {
        dialogSalirPresupuesto.close(false);
      }
    });
  }

  rowIsSelected(pkId: number) {
    return this.selectedRowIds.has(pkId);
  }

  private rowToggle(pkId: number) {
    if (this.selectedRowIds.has(pkId)) {
      this.selectedRowIds.delete(pkId);
    } else {
      this.selectedRowIds.add(pkId);
    }
    this.descripcionPartida = '';
    this.partidaActual = 0;
    this.xpandStatus = false;
    this.xpandDisabled = true;
    this.referenciaPartida = "(clic en tabla)";
    this.precioUnitario = 0;
  }

  getSelectedRows() {
    return this.dataSourceFilters.data.filter((x) => this.selectedRowIds.has(x.position));
  }

  private selectRowRange(from: number, to: number) {
    if (to < from) {
      var tmp = from;
      from = to;
      to = tmp;
    }
    this.dataSourceFilters.data.forEach((x) => {
      if (x.position >= from && x.position <= to) {
        this.selectedRowIds.add(x.position);
      }
    });
    this.descripcionPartida = '';
    this.partidaActual = 0;
    this.xpandStatus = false;
    this.xpandDisabled = true;
    this.referenciaPartida = "(no aplica)";
    this.precioUnitario = 0;
  }

  public onRowClick(row: BudgetItem, event: MouseEvent) {
    let pkId: number = row.position;
    if ((!event.shiftKey && !event.ctrlKey) || this.rowCursor == -1) {
      if (this.selectedRowIds.size == 1 && this.rowIsSelected(pkId)) {
        this.rowToggle(pkId);
      } else {
        this.selectedRowIds.clear();
        this.selectedRowIds.add(pkId);
        this.verDescripcionPartida(pkId);
        this.verResumenPartida(row);

      }
    }
    else if (event.ctrlKey && !event.shiftKey) {
      this.rowToggle(pkId);
    }
    else if (event.shiftKey && !event.ctrlKey) {
      this.selectRowRange(this.rowCursor, pkId);
    }
    this.rowCursor = pkId;
  }

  private getListReferencePartidas(listBudgetItem: BudgetItem[]) {
    this.listReferencePartidas = [];
    for (let i = 0; i < this.getSelectedRows().length; i++) {
      let rowPartida = this.getSelectedRows()[i];
      for (let j = 0; j < listBudgetItem.length; j++) {
        let partida = listBudgetItem[j];
        if (partida.reference == rowPartida.reference) {
          this.listReferencePartidas.push(partida.reference);
          break;
        }
      }
    }
  }

  verDetallePartida(row: BudgetItem) {
    this.verDescripcionPartida(row.position);
    this.helperClassService.setData(this.infoPresupuesto);
    this.dialogVerPartidas.open(VerApuPresupuestoComponent, { width: '100%', maxWidth: '100%', height: '100%', data: row });
  }

  modificarPartida() {
    if (this.getSelectedRows().length > 0) {
      document.body.classList.add("cdk-global-scrollblock");
      this.dialogModificarPartida.open(
        ModificarPartidaPresupuestoComponent, { width: '26rem', data: this.getSelectedRows()[0] }
      ).afterClosed().subscribe(() => {
        document.body.classList.remove("cdk-global-scrollblock");
      });
    } else {
      this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_LINEITEM_EMPTY, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
    }
  }

  async borrarPartidaPresupuesto() {
    if (this.getSelectedRows().length > 0) {
      this.apiCallService.showSpinner();
      for await (let lineItemBudget of this.getSelectedRows()) {
        this.cachePartidasService.delete(lineItemBudget.idLineItem.toString());
      }
      this.descripcionPartida = '';
      this.partidaActual = 0;
      this.selectedRowIds.clear();
      this.xpandStatus = false;
      this.xpandDisabled = true;
      this.referenciaPartida = "(clic en tabla)";
      this.precioUnitario = 0;
      this.apiCallService.hideSpinner();
    } else {
      this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_LINEITEM_EMPTY, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
    }
  }

  async verDetallePresupuestoPDF() {
    if (this.dataSourceFilters.data.length > 0) {
      let firmantes: BudgetSignatures[] = [];
      let reportpDFName = Constanst.PDF_REPORT_NAME_BUDGET;
      let reportpDFWatermark = String(await this.helperClassService.toBase64Image(Constanst.PDF_REPORT_WATERMARK));

      var rowsPartidasPresupuesto: any[] = [];
      rowsPartidasPresupuesto.push([{ text: 'Part. No', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Descripción', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Und.', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Cantidad', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Precio Unitario', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Total Bs.', style: 'subheader', bold: true, alignment: 'center' }]);
      for (var [i, partida] of this.dataSourceFilters.data.entries()) {
        rowsPartidasPresupuesto.push([{ text: (i + 1), alignment: 'center', style: 'subheader', border: [true, false, true, false] }, { text: partida.code.concat('\n ' + partida.description), alignment: 'left', style: 'subheader', border: [true, false, true, false] }, { text: partida.unit, alignment: 'center', style: 'subheader', border: [true, false, true, false] }, { text: this.decimalPipe.transform(partida.quantity, '1.2-2', 'es'), alignment: 'right', style: 'subheader', border: [true, false, true, false] }, { text: this.decimalPipe.transform(partida.unitPrice, '1.2-2', 'es'), alignment: 'right', style: 'subheader', border: [true, false, true, false] }, { text: this.decimalPipe.transform(partida.total, '1.2-2', 'es'), alignment: 'right', style: 'subheader', border: [true, false, true, false] }]);
      };
      rowsPartidasPresupuesto.push([{ text: 'Total Presupuesto', style: 'subheader', bold: true, colSpan: 4, alignment: 'right', border: [false, true, false, false] }, {}, {}, {}, { text: this.decimalPipe.transform(this.budgeTotal, '1.2-2', 'es'), alignment: 'right', style: 'subheader', bold: true, colSpan: 2 }]);
      rowsPartidasPresupuesto.push([{ text: 'Total I.V.A.(' + this.budgetlIva + '%)', style: 'subheader', bold: true, colSpan: 4, alignment: 'right', border: [false, false, false, false] }, {}, {}, {}, { text: this.decimalPipe.transform(this.budgetTotalIva, '1.2-2', 'es'), alignment: 'right', style: 'subheader', bold: true, colSpan: 2 }]);
      rowsPartidasPresupuesto.push([{ text: 'Total Otros Impuestos(' + this.budgetOtherTax + '%)', style: 'subheader', bold: true, colSpan: 4, alignment: 'right', border: [false, false, false, false] }, {}, {}, {}, { text: this.decimalPipe.transform(this.budgetTotalOtherTax, '1.2-2', 'es'), alignment: 'right', style: 'subheader', bold: true, colSpan: 2 }]);
      rowsPartidasPresupuesto.push([{ text: 'Total General', style: 'subheader', bold: true, colSpan: 4, alignment: 'right', border: [false, false, false, false] }, {}, {}, {}, { text: this.decimalPipe.transform(this.budgetGrandTotal, '1.2-2', 'es'), alignment: 'right', style: 'subheader', bold: true, colSpan: 2 }]);
      firmantes = this.infoPresupuesto.signatures;
      let companyBudget = this.infoPresupuesto.companyBudget;
      let docDefinition = {
        pageMargin: [5, 5, 5, 70],//[left, top, right, bottom][5, 50, 20, 20]
        pageSizes: Constanst.PDF_REPORT_PAGE_SIZE,
        background: {
          image: reportpDFWatermark,
          width: 600,
          absolutePosition: {
            x: 0, //Centra horizontalmente
            y: 100 //Centra verticalmente
          }
        },
        header: function (currentPage: any, pageCount: any) {
          return {
          margin: 8,
          table: {
            widths: ['*', '*'],
            body: [
              [{ text: companyBudget, fontSize: 12, bold: true, alignment: 'left', border: [false, false, false, false] },
                { text: Constanst.PDF_REPORT_HADER_TEXT.concat('\n').concat(Constanst.PDF_REPORT_FOOTER_ONE + currentPage.toString() + Constanst.PDF_REPORT_FOOTER_TWO + pageCount), style: 'small', border: [false, false, false, false], alignment: 'right' }]
            ]
          }
          };
        },
        footer: function (currentPage: any, pageCount: any) {
          if (currentPage == pageCount) {
            return {
              alignments: 'center',
              style: 'tableExample',
              table: {
                widths: Array(firmantes.length).fill('*'),
                body: [firmantes.map(firmante => (
                  { text: `${firmante.description}\n${firmante.name}\n${firmante.ci}`, alignment: 'center', border: [false, false, false, false] }
                ))]
              }
            };
          }
          return '';
        },
        info: {
          title: reportpDFName,
          author: Constanst.PDF_REPORT_INFO_AUTHOR,
          subject: Constanst.PDF_REPORT_INFO_SUBJECT,
          keywords: Constanst.PDF_REPORT_INFO_KEYWORDS,
          creator: Constanst.PDF_REPORT_INFO_CREATOR,
          producer: Constanst.PDF_REPORT_INFO_PRODUCER
        },
        content: [
          {
            table: {
              widths: ['*'],
              body: [
                [{ text: 'P R E S U P U E S T O', fontSize: 13, bold: true, alignment: 'center', border: [false, false, false, false] }]
              ]
            }
          },
          {
            style: 'tableExample',
            table: {
              widths: ['*'],
              body: [
                [{ text: 'Obra: '.concat(this.infoPresupuesto.budgetName), fontSize: 10, bold: true, alignment: 'left', margin: [0, 2, 0, 0], border: [false, false, false, false] }]
              ]
            }
          },
          {
            style: 'tableExample',
            table: {
              widths: ['*'],
              body: [
                [{ text: 'Contratante: '.concat(this.infoPresupuesto.contractor), fontSize: 10, bold: true, alignment: 'left', margin: [0, 0, 0, 2], border: [false, false, false, false] }]
              ]
            }
          },
          {
            style: 'tableExample',
            table: {
              headerRows: 1,
              widths: [38, 240, 30, 40, 63, 60],
              body: rowsPartidasPresupuesto
            }
          }
        ],
        styles: {
          header: {
            fontSize: 9,
            bold: true
          },
          subheader: {
            fontSize: 9
          },
          quote: {
            italics: true
          },
          small: {
            fontSize: 8
          },
          tableExample: {
            fontSize: 9
          }
        }
      };
      pdfMake.createPdf(docDefinition).open();
    } else {
      this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_EMPTY_BUDGET, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
    }
  }

  async verResumenMaterialesPresupuestoPDF() {
    if (this.dataSourceFilters.data.length > 0) {
      this.route = '/getMaterialByBudgetLineItem';
      this.method = 'POST';
      let data = {
        idBudget: this.infoPresupuesto.budgetId
      }
      this.apiCallService.call$(data, this.route, this.method, true, '', true)
        .pipe(takeUntil(this.destroy$)).subscribe(async response => {
          if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
            if (response.data.length > 0) {
              let reportpDFName = Constanst.PDF_REPORT_NAME_BUDGET_MATERIAL;
              let reportpDFWatermark = String(await this.helperClassService.toBase64Image(Constanst.PDF_REPORT_WATERMARK));
              var listMaterialesPresupuesto: any[] = []; var rowsPartidasPresupuesto: any[] = [];
              listMaterialesPresupuesto = response.data;
              listMaterialesPresupuesto.sort((a, b) => a.materialCode.localeCompare(b.materialCode));
              rowsPartidasPresupuesto.push([{ text: 'Referencia', style: 'subheader', bold: true, alignment: 'center', border: [false, false, false, true] }, { text: 'Descripción', style: 'subheader', bold: true, alignment: 'center', border: [false, false, false, true] }, { text: 'Unidad', style: 'subheader', bold: true, alignment: 'center', border: [false, false, false, true] }, { text: 'Cant. Presp.', style: 'subheader', bold: true, alignment: 'center', border: [false, false, false, true] }, { text: 'Precio Material Bs.', style: 'subheader', bold: true, alignment: 'center', border: [false, false, false, true] }, { text: 'Total Bs.', style: 'subheader', bold: true, alignment: 'center', border: [false, false, false, true] }]);
              for (var [i, material] of listMaterialesPresupuesto.entries()) {
                rowsPartidasPresupuesto.push([{ text: material.materialCode, alignment: 'left', style: 'subheader', border: [false, false, false, false] }, { text: material.materialDescription, alignment: 'left', style: 'subheader', border: [false, false, false, false] }, { text: material.unitDescription, alignment: 'center', style: 'subheader', border: [false, false, false, false] }, { text: this.decimalPipe.transform(material.materialQuantity, '1.4-4', 'es'), alignment: 'right', style: 'subheader', border: [false, false, false, false] }, { text: this.decimalPipe.transform(material.price, '1.2-2', 'es'), alignment: 'right', style: 'subheader', border: [false, false, false, false] }, { text: this.decimalPipe.transform((material.totalPriceMaterial), '1.2-2', 'es'), alignment: 'right', style: 'subheader', border: [false, false, false, false] }]);
              };
              rowsPartidasPresupuesto.push([{ text: 'Total General', fontSize: 9, bold: true, colSpan: 4, alignment: 'right', border: [false, false, false, false] }, {}, {}, {}, { text: this.decimalPipe.transform(listMaterialesPresupuesto.map((t: { totalPriceMaterial: any; }) => t.totalPriceMaterial).reduce((acc: number, value: number) => acc + value, 0), '1.2-2', 'es'), alignment: 'right', fontSize: 9, bold: true, border: [false, false, false, false], colSpan: 2 }]);
              let companyBudget = this.infoPresupuesto.companyBudget;
              let docDefinition = {
                pageMargin: [5, 50, 5, 10],
                pageSizes: Constanst.PDF_REPORT_PAGE_SIZE,
                background: {
                  image: reportpDFWatermark,
                  width: 600,
                  absolutePosition: {
                    x: 0, //Centra horizontalmente
                    y: 100 //Centra verticalmente
                  }
                },
                header: function (currentPage: any, pageCount: any) {
                  return {
                  margin: 8,
                  table: {
                    widths: ['*', '*'],
                    body: [
                      [{ text: companyBudget, fontSize: 12, bold: true, alignment: 'left', border: [false, false, false, false] },
                        { text: Constanst.PDF_REPORT_HADER_TEXT.concat('\n').concat(Constanst.PDF_REPORT_FOOTER_ONE + currentPage.toString() + Constanst.PDF_REPORT_FOOTER_TWO + pageCount), style: 'small', border: [false, false, false, false], alignment: 'right' }]
                    ]
                  }
                  };
                },
                info: {
                  title: reportpDFName,
                  author: Constanst.PDF_REPORT_INFO_AUTHOR,
                  subject: Constanst.PDF_REPORT_INFO_SUBJECT,
                  keywords: Constanst.PDF_REPORT_INFO_KEYWORDS,
                  creator: Constanst.PDF_REPORT_INFO_CREATOR,
                  producer: Constanst.PDF_REPORT_INFO_PRODUCER
                },
                content: [
                  {
                    table: {
                      widths: ['*'],
                      body: [
                        [{ text: 'RESUMEN DE MATERIALES DEL PRESUPUESTO', fontSize: 12, bold: true, alignment: 'center', border: [false, false, false, false] }]
                      ]
                    }
                  },
                  {
                    style: 'tableExample',
                    table: {
                      widths: ['*'],
                      body: [
                        [{ text: 'Obra: '.concat(this.infoPresupuesto.budgetName), fontSize: 10, bold: true, alignment: 'left', margin: [0, 2, 0, 0], border: [false, false, false, false] }]
                      ]
                    }
                  },
                  {
                    style: 'tableExample',
                    table: {
                      widths: ['*'],
                      body: [
                        [{ text: 'Contratante: '.concat(this.infoPresupuesto.contractor), fontSize: 10, bold: true, alignment: 'left', margin: [0, 0, 0, 2], border: [false, false, false, false] }]
                      ]
                    }
                  },
                  {
                    style: 'tableExample',
                    table: {
                      headerRows: 1,
                      widths: [45, 200, 30, 55, 80, 65],
                      body: rowsPartidasPresupuesto
                    }
                  }
                ],
                styles: {
                  header: {
                    fontSize: 9,
                    bold: true
                  },
                  subheader: {
                    fontSize: 8
                  },
                  quote: {
                    italics: true
                  },
                  small: {
                    fontSize: 8
                  },
                  tableExample: {
                    fontSize: 9
                  }
                }
              };
              this.apiCallService.hideSpinner();
              pdfMake.createPdf(docDefinition).open();
            } else {
              this.apiCallService.hideSpinner();
              this.helperClassService.openDialogGeneric('25rem', true, 'Presupuesto no tiene materiales', false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
            }
          } else {
            this.apiCallService.hideSpinner();
            this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
          }
        });
    } else {
      this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_EMPTY_BUDGET, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
    }
  }

  async verResumenEquiposPresupuestoPDF() {
    if (this.dataSourceFilters.data.length > 0) {
      this.route = '/getEquipmenstByBudgetLineItem';
      this.method = 'POST';
      let data = {
        idBudget: this.infoPresupuesto.budgetId
      }
      this.apiCallService.call$(data, this.route, this.method, true, '', true)
        .pipe(takeUntil(this.destroy$)).subscribe(async response => {
          if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
            if (response.data.length > 0) {
              let reportpDFName = Constanst.PDF_REPORT_NAME_BUDGET_EQUIPMENT;
              let reportpDFWatermark = String(await this.helperClassService.toBase64Image(Constanst.PDF_REPORT_WATERMARK));
              var listEquiposPresupuesto: any[] = []; var rowsEquiposPresupuesto: any[] = [];
              listEquiposPresupuesto = response.data;
              listEquiposPresupuesto.sort((a, b) => a.reference.localeCompare(b.reference));
              rowsEquiposPresupuesto.push([{ text: 'Referencia', style: 'subheader', bold: true, alignment: 'center', border: [false, false, false, true] }, { text: 'Descripción', style: 'subheader', bold: true, alignment: 'center', border: [false, false, false, true] }, { text: 'Precio Bs.', style: 'subheader', bold: true, alignment: 'center', border: [false, false, false, true] }, { text: 'COP/Dep.', style: 'subheader', bold: true, alignment: 'center', border: [false, false, false, true] }, { text: 'Cantidad', style: 'subheader', bold: true, alignment: 'center', border: [false, false, false, true] }, { text: 'Total Bs.', style: 'subheader', bold: true, alignment: 'center', border: [false, false, false, true] }]);
              for (var [i, equipo] of listEquiposPresupuesto.entries()) {
                rowsEquiposPresupuesto.push([{ text: equipo.reference, alignment: 'left', style: 'subheader', border: [false, false, false, false] }, { text: equipo.descriptionLabor, alignment: 'left', style: 'subheader', border: [false, false, false, false] }, { text: this.decimalPipe.transform(equipo.priceEquipment, '1.2-2', 'es'), alignment: 'right', style: 'subheader', border: [false, false, false, false] }, { text: this.decimalPipe.transform(equipo.copDep, '1.6-6', 'es'), alignment: 'right', style: 'subheader', border: [false, false, false, false] }, { text: this.decimalPipe.transform(equipo.equipmentQuantity, '1.4-4', 'es'), alignment: 'right', style: 'subheader', border: [false, false, false, false] }, { text: this.decimalPipe.transform(equipo.totalPriceEquipment, '1.2-2', 'es'), alignment: 'right', style: 'subheader', border: [false, false, false, false] }]);
              };
              rowsEquiposPresupuesto.push([{ text: 'Total General', fontSize: 9, bold: true, colSpan: 4, alignment: 'right', border: [false, false, false, false] }, {}, {}, {}, { text: this.decimalPipe.transform(listEquiposPresupuesto.map((t: { totalPriceEquipment: any; }) => t.totalPriceEquipment).reduce((acc: number, value: number) => acc + value, 0), '1.2-2', 'es'), alignment: 'right', fontSize: 9, bold: true, border: [false, false, false, false], colSpan: 2 }]);
              rowsEquiposPresupuesto.push([{ text: 'Nota: La cantidad necesaria de equipos con presencia física en la obra depende del cronograma de trabajo, el cual definirá la simultaneidad de las actividades.', style: 'small', colSpan: 6, alignment: 'left', border: [false, false, false, false] }, {}, {}, {}, {}, {}]);
              let companyBudget = this.infoPresupuesto.companyBudget;
              let docDefinition = {
                pageMargin: [5, 50, 5, 10],
                pageSizes: Constanst.PDF_REPORT_PAGE_SIZE,
                background: {
                  image: reportpDFWatermark,
                  width: 600,
                  absolutePosition: {
                    x: 0, //Centra horizontalmente
                    y: 100 //Centra verticalmente
                  }
                },
                header: function (currentPage: any, pageCount: any) {
                  return {
                  margin: 8,
                  table: {
                    widths: ['*', '*'],
                    body: [
                      [{ text: companyBudget, fontSize: 12, bold: true, alignment: 'left', border: [false, false, false, false] },
                        { text: Constanst.PDF_REPORT_HADER_TEXT.concat('\n').concat(Constanst.PDF_REPORT_FOOTER_ONE + currentPage.toString() + Constanst.PDF_REPORT_FOOTER_TWO + pageCount), style: 'small', border: [false, false, false, false], alignment: 'right' }]
                    ]
                  }
                  };
                },
                info: {
                  title: reportpDFName,
                  author: Constanst.PDF_REPORT_INFO_AUTHOR,
                  subject: Constanst.PDF_REPORT_INFO_SUBJECT,
                  keywords: Constanst.PDF_REPORT_INFO_KEYWORDS,
                  creator: Constanst.PDF_REPORT_INFO_CREATOR,
                  producer: Constanst.PDF_REPORT_INFO_PRODUCER
                },
                content: [
                  {
                    table: {
                      widths: ['*'],
                      body: [
                        [{ text: 'RESUMEN DE EQUIPOS DEL PRESUPUESTO', fontSize: 12, bold: true, alignment: 'center', border: [false, false, false, false] }]
                      ]
                    }
                  },
                  {
                    style: 'tableExample',
                    table: {
                      widths: ['*'],
                      body: [
                        [{ text: 'Obra: '.concat(this.infoPresupuesto.budgetName), fontSize: 10, bold: true, alignment: 'left', margin: [0, 2, 0, 0], border: [false, false, false, false] }]
                      ]
                    }
                  },
                  {
                    style: 'tableExample',
                    table: {
                      widths: ['*'],
                      body: [
                        [{ text: 'Contratante: '.concat(this.infoPresupuesto.contractor), fontSize: 10, bold: true, alignment: 'left', margin: [0, 0, 0, 2], border: [false, false, false, false] }]
                      ]
                    }
                  },
                  {
                    style: 'tableExample',
                    table: {
                      headerRows: 1,
                      widths: [40, 205, 65, 50, 50, 65],
                      body: rowsEquiposPresupuesto
                    }
                  }
                ],
                styles: {
                  header: {
                    fontSize: 9,
                    bold: true
                  },
                  subheader: {
                    fontSize: 8
                  },
                  quote: {
                    italics: true
                  },
                  small: {
                    fontSize: 8
                  },
                  tableExample: {
                    fontSize: 9
                  }
                }
              };
              this.apiCallService.hideSpinner();
              pdfMake.createPdf(docDefinition).open();
            } else {
              this.apiCallService.hideSpinner();
              this.helperClassService.openDialogGeneric('25rem', true, 'Presupuesto no tiene equipos', false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
            }
          } else {
            this.apiCallService.hideSpinner();
            this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
          }
        });
    } else {
      this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_EMPTY_BUDGET, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
    }
  }

  async verResumenManoObraresupuestoPDF() {
    if (this.dataSourceFilters.data.length > 0) {
      this.route = '/getLaborByBudgetLineItem';
      this.method = 'POST';
      let data = {
        idBudget: this.infoPresupuesto.budgetId
      }
      this.apiCallService.call$(data, this.route, this.method, true, '', true)
        .pipe(takeUntil(this.destroy$)).subscribe(async response => {
          if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
            if (response.data.length > 0) {
              let reportpDFName = Constanst.PDF_REPORT_NAME_BUDGET_LABOR;
              let reportpDFWatermark = String(await this.helperClassService.toBase64Image(Constanst.PDF_REPORT_WATERMARK));
              var listManoObraPresupuesto: any[] = []; var rowsManoObraPresupuesto: any[] = [];
              listManoObraPresupuesto = response.data;
              listManoObraPresupuesto.sort((a, b) => a.reference.localeCompare(b.reference));
              rowsManoObraPresupuesto.push([{ text: 'Referencia', style: 'subheader', bold: true, alignment: 'center', border: [false, false, false, true] }, { text: 'Descripción', style: 'subheader', bold: true, alignment: 'center', border: [false, false, false, true] }, { text: 'Jornal', style: 'subheader', bold: true, alignment: 'center', border: [false, false, false, true] }, { text: 'Bono', style: 'subheader', bold: true, alignment: 'center', border: [false, false, false, true] }, { text: 'Cant. Presp.', style: 'subheader', bold: true, alignment: 'center', border: [false, false, false, true] }, { text: 'Total Bs.', style: 'subheader', bold: true, alignment: 'center', border: [false, false, false, true] }]);
              for (var [i, manoObra] of listManoObraPresupuesto.entries()) {
                rowsManoObraPresupuesto.push([{ text: manoObra.reference, alignment: 'left', style: 'subheader', border: [false, false, false, false] }, { text: manoObra.descriptionLabor, alignment: 'left', style: 'subheader', border: [false, false, false, false] }, { text: this.decimalPipe.transform(manoObra.jornalBs, '1.2-2', 'es'), alignment: 'right', style: 'subheader', border: [false, false, false, false] }, { text: this.decimalPipe.transform(manoObra.bonusBs, '1.2-2', 'es'), alignment: 'right', style: 'subheader', border: [false, false, false, false] }, { text: this.decimalPipe.transform(manoObra.laborQuantity, '1.4-4', 'es'), alignment: 'right', style: 'subheader', border: [false, false, false, false] }, { text: this.decimalPipe.transform(manoObra.totalBsEquipment, '1.2-2', 'es'), alignment: 'right', style: 'subheader', border: [false, false, false, false] }]);
              };
              rowsManoObraPresupuesto.push([{ text: 'Total General', fontSize: 9, bold: true, colSpan: 4, alignment: 'right', border: [false, false, false, false] }, {}, {}, {}, { text: this.decimalPipe.transform(listManoObraPresupuesto.map((t: { totalBsEquipment: any; }) => t.totalBsEquipment).reduce((acc: number, value: number) => acc + value, 0), '1.2-2', 'es'), alignment: 'right', fontSize: 9, bold: true, border: [false, false, false, false], colSpan: 2 }]);
              rowsManoObraPresupuesto.push([{ text: 'Nota: La cantidad necesaria de trabajadores con presencia física en la obra depende del cronograma de trabajo, el cual definirá la simultaneidad de las actividades.', style: 'small', colSpan: 6, alignment: 'left', border: [false, false, false, false] }, {}, {}, {}, {}, {}]);
              rowsManoObraPresupuesto.push([{ text: 'Total línea= ((Jornal + Jornal x %FCAS/100 x Bono) x Cant. Partida) / Rendimiento (FCAS de cada APU)', style: 'small', colSpan: 6, alignment: 'left', border: [false, false, false, false] }, {}, {}, {}, {}, {}]);
              let companyBudget = this.infoPresupuesto.companyBudget;
              let docDefinition = {
                pageMargin: [5, 50, 5, 10],
                pageSizes: Constanst.PDF_REPORT_PAGE_SIZE,
                background: {
                  image: reportpDFWatermark,
                  width: 600,
                  absolutePosition: {
                    x: 0, //Centra horizontalmente
                    y: 100 //Centra verticalmente
                  }
                },
                header: function (currentPage: any, pageCount: any) {
                  return {
                  margin: 8,
                  table: {
                    widths: ['*', '*'],
                    body: [
                      [{ text: companyBudget, fontSize: 12, bold: true, alignment: 'left', border: [false, false, false, false] },
                        { text: Constanst.PDF_REPORT_HADER_TEXT.concat('\n').concat(Constanst.PDF_REPORT_FOOTER_ONE + currentPage.toString() + Constanst.PDF_REPORT_FOOTER_TWO + pageCount), style: 'small', border: [false, false, false, false], alignment: 'right' }]
                    ]
                  }
                  };
                },
                info: {
                  title: reportpDFName,
                  author: Constanst.PDF_REPORT_INFO_AUTHOR,
                  subject: Constanst.PDF_REPORT_INFO_SUBJECT,
                  keywords: Constanst.PDF_REPORT_INFO_KEYWORDS,
                  creator: Constanst.PDF_REPORT_INFO_CREATOR,
                  producer: Constanst.PDF_REPORT_INFO_PRODUCER
                },
                content: [
                  {
                    table: {
                      widths: ['*'],
                      body: [
                        [{ text: 'RESUMEN DE MANO DE OBRA DEL PRESUPUESTO', fontSize: 12, bold: true, alignment: 'center', border: [false, false, false, false] }]
                      ]
                    }
                  },
                  {
                    style: 'tableExample',
                    table: {
                      widths: ['*'],
                      body: [
                        [{ text: 'Obra: '.concat(this.infoPresupuesto.budgetName), fontSize: 10, bold: true, alignment: 'left', margin: [0, 2, 0, 0], border: [false, false, false, false] }]
                      ]
                    }
                  },
                  {
                    style: 'tableExample',
                    table: {
                      widths: ['*'],
                      body: [
                        [{ text: 'Contratante: '.concat(this.infoPresupuesto.contractor), fontSize: 10, bold: true, alignment: 'left', margin: [0, 0, 0, 2], border: [false, false, false, false] }]
                      ]
                    }
                  },
                  {
                    style: 'tableExample',
                    table: {
                      headerRows: 1,
                      widths: [40, 200, 65, 50, 55, 65],
                      body: rowsManoObraPresupuesto
                    }
                  }
                ],
                styles: {
                  header: {
                    fontSize: 9,
                    bold: true
                  },
                  subheader: {
                    fontSize: 8
                  },
                  quote: {
                    italics: true
                  },
                  small: {
                    fontSize: 8
                  },
                  tableExample: {
                    fontSize: 9
                  }
                }
              };
              this.apiCallService.hideSpinner();
              pdfMake.createPdf(docDefinition).open();
            } else {
              this.apiCallService.hideSpinner();
              this.helperClassService.openDialogGeneric('25rem', true, 'Presupuesto no tiene mano de obra', false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
            }
          } else {
            this.apiCallService.hideSpinner();
            this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
          }
        });
    } else {
      this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_EMPTY_BUDGET, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
    }
  }

  async verDetallePresupuestoConCapitulosPDF() {
    if (this.dataSourceFilters.data.length > 0) {
      let firmantes: BudgetSignatures[] = [];
      let reportpDFName = Constanst.PDF_REPORT_NAME_BUDGET_CHAPTER;
      let reportpDFWatermark = String(await this.helperClassService.toBase64Image(Constanst.PDF_REPORT_WATERMARK));
      var rowsPartidasPresupuesto: any[] = [];
      var capitulosSinRepetir: string[] = [];
      let listTempBudgetItem: BudgetItem[] = this.dataSourceFilters.data;
      let totalCapitulo: number = 0;
      rowsPartidasPresupuesto.push([{ text: 'Part. No', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Descripción', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Und.', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Cantidad', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Precio Unitario', style: 'subheader', bold: true, alignment: 'center' }, { text: 'Total Bs.', style: 'subheader', bold: true, alignment: 'center' }]);

      for (var [i, partida] of listTempBudgetItem.entries()) {
        let tipoActual = (partida.chapterReference != null && partida.chapterReference.trim() != '' ? partida.descriptionChapter!.trim() : Constanst.CHAPTER_DESCRIPTION_EMPTY);
        if (!capitulosSinRepetir.includes(tipoActual)) {
          capitulosSinRepetir.push(tipoActual);
        }
      }
      capitulosSinRepetir = capitulosSinRepetir.sort((a, b) => a.localeCompare(b));
      let position = 0;
      for (let j = 0; j < capitulosSinRepetir.length; j++) {
        let capitulo = capitulosSinRepetir[j];
        totalCapitulo = 0;
        rowsPartidasPresupuesto.push([{ text: '', alignment: 'center', border: [true, false, true, false] }, { text: capitulo, alignment: 'left', style: 'subheader', bold: true, margin: [0, 2, 0, 0], border: [true, false, true, false] }, { text: '', alignment: 'center', border: [true, false, true, false] }, { text: '', alignment: 'right', border: [true, false, true, false] }, { text: '', alignment: 'right', border: [true, false, true, false] }, { text: '', alignment: 'right', border: [true, false, true, false] }]);
        for (let i = 0; i < listTempBudgetItem.length; i++) {
          let partida = listTempBudgetItem[i];
          let capituloPartida = (partida.chapterReference == null || partida.chapterReference.trim() == '' ? Constanst.CHAPTER_DESCRIPTION_EMPTY : partida.descriptionChapter!.trim());
          if (capituloPartida === capitulo) {
            let rowData = [{ text: (position += 1), alignment: 'center', style: 'subheader', border: [true, false, true, false] }, { text: partida.code.concat('\n ' + partida.description), alignment: 'left', style: 'subheader', border: [true, false, true, false] }, { text: partida.unit, alignment: 'center', style: 'subheader', border: [true, false, true, false] }, { text: this.decimalPipe.transform(partida.quantity, '1.2-2', 'es'), alignment: 'right', style: 'subheader', border: [true, false, true, false] }, { text: this.decimalPipe.transform(partida.unitPrice, '1.2-2', 'es'), alignment: 'right', style: 'subheader', border: [true, false, true, false] }, { text: this.decimalPipe.transform(partida.total, '1.2-2', 'es'), alignment: 'right', style: 'subheader', border: [true, false, true, false] }];
            rowsPartidasPresupuesto.push(rowData);
            totalCapitulo += partida.total;
          }
        }
        rowsPartidasPresupuesto.push([{ text: '', alignment: 'center', border: [true, false, true, false] }, { text: 'Total Bs. '.concat(capitulo).concat(': ' + this.decimalPipe.transform(totalCapitulo, '1.2-2', 'es')), alignment: 'right', style: 'subheader', bold: true, margin: [0, 2, 0, 0], border: [true, false, true, false] }, { text: '', alignment: 'center', border: [true, false, true, false] }, { text: '', alignment: 'right', border: [true, false, true, false] }, { text: '', alignment: 'right', border: [true, false, true, false] }, { text: '', alignment: 'right', border: [true, false, true, false] }]);
      }

      rowsPartidasPresupuesto.push([{ text: 'Total Presupuesto', style: 'subheader', bold: true, colSpan: 4, alignment: 'right', border: [false, true, false, false] }, {}, {}, {}, { text: this.decimalPipe.transform(this.budgeTotal, '1.2-2', 'es'), alignment: 'right', style: 'subheader', bold: true, colSpan: 2 }]);
      rowsPartidasPresupuesto.push([{ text: 'Total I.V.A.(' + this.budgetlIva + '%)', style: 'subheader', bold: true, colSpan: 4, alignment: 'right', border: [false, false, false, false] }, {}, {}, {}, { text: this.decimalPipe.transform(this.budgetTotalIva, '1.2-2', 'es'), alignment: 'right', style: 'subheader', bold: true, colSpan: 2 }]);
      rowsPartidasPresupuesto.push([{ text: 'Total Otros Impuestos(' + this.budgetOtherTax + '%)', style: 'subheader', bold: true, colSpan: 4, alignment: 'right', border: [false, false, false, false] }, {}, {}, {}, { text: this.decimalPipe.transform(this.budgetTotalOtherTax, '1.2-2', 'es'), alignment: 'right', style: 'subheader', bold: true, colSpan: 2 }]);
      rowsPartidasPresupuesto.push([{ text: 'Total General', style: 'subheader', bold: true, colSpan: 4, alignment: 'right', border: [false, false, false, false] }, {}, {}, {}, { text: this.decimalPipe.transform(this.budgetGrandTotal, '1.2-2', 'es'), alignment: 'right', style: 'subheader', bold: true, colSpan: 2 }]);
      firmantes = this.infoPresupuesto.signatures;
      let companyBudget = this.infoPresupuesto.companyBudget;
      let docDefinition = {
        pageMargin: [5, 50, 20, 20],
        pageSizes: Constanst.PDF_REPORT_PAGE_SIZE,
        background: {
          image: reportpDFWatermark,
          width: 600,
          absolutePosition: {
            x: 0, //Centra horizontalmente
            y: 100 //Centra verticalmente
          }
        },
        header: function (currentPage: any, pageCount: any) {
          return {
          margin: 8,
          table: {
            widths: ['*', '*'],
            body: [
              [{ text: companyBudget, fontSize: 12, bold: true, alignment: 'left', border: [false, false, false, false] },
                { text: Constanst.PDF_REPORT_HADER_TEXT.concat('\n').concat(Constanst.PDF_REPORT_FOOTER_ONE + currentPage.toString() + Constanst.PDF_REPORT_FOOTER_TWO + pageCount), style: 'small', border: [false, false, false, false], alignment: 'right' }]
            ]
          }
          };
        },
        footer: function (currentPage: any, pageCount: any) {
          if (currentPage == pageCount) {
            return {
              alignments: 'center',
              style: 'tableExample',
              table: {
                widths: Array(firmantes.length).fill('*'),
                body: [firmantes.map(firmante => (
                  { text: `${firmante.description}\n${firmante.name}\n${firmante.ci}`, alignment: 'center', border: [false, false, false, false] }
                ))]
              }
            };
          }
          return '';
        },
        info: {
          title: reportpDFName,
          author: Constanst.PDF_REPORT_INFO_AUTHOR,
          subject: Constanst.PDF_REPORT_INFO_SUBJECT,
          keywords: Constanst.PDF_REPORT_INFO_KEYWORDS,
          creator: Constanst.PDF_REPORT_INFO_CREATOR,
          producer: Constanst.PDF_REPORT_INFO_PRODUCER
        },
        content: [
          {
            table: {
              widths: ['*'],
              body: [
                [{ text: 'P R E S U P U E S T O', fontSize: 13, bold: true, alignment: 'center', border: [false, false, false, false] }]
              ]
            }
          },
          {
            style: 'tableExample',
            table: {
              widths: ['*'],
              body: [
                [{ text: 'Obra: '.concat(this.infoPresupuesto.budgetName), fontSize: 10, bold: true, alignment: 'left', margin: [0, 2, 0, 0], border: [false, false, false, false] }]
              ]
            }
          },
          {
            style: 'tableExample',
            table: {
              widths: ['*'],
              body: [
                [{ text: 'Contratante: '.concat(this.infoPresupuesto.contractor), fontSize: 10, bold: true, alignment: 'left', margin: [0, 0, 0, 2], border: [false, false, false, false] }]
              ]
            }
          },
          {
            style: 'tableExample',
            table: {
              headerRows: 1,
              widths: [38, 240, 30, 40, 63, 60],
              body: rowsPartidasPresupuesto
            }
          }
        ],
        styles: {
          header: {
            fontSize: 9,
            bold: true
          },
          subheader: {
            fontSize: 9
          },
          quote: {
            italics: true
          },
          small: {
            fontSize: 8
          },
          tableExample: {
            fontSize: 9
          }
        }
      };
      pdfMake.createPdf(docDefinition).open();
    } else {
      this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_EMPTY_BUDGET, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
    }
  }

  actualizarPresupuesto() {
    this.route = '/updateBudgetNew';
    this.method = 'POST';
    let listBudgetLineItemQuantities: BudgetLineItemQuantities[] = [];
    let listBudgetAllLineItem: BudgetItem[] = [];
    this.cachePartidasService.getAll().subscribe((dataBudgetItem: BudgetItem[]) => {
      listBudgetAllLineItem = dataBudgetItem;
    });

    for (let i = 0; i < listBudgetAllLineItem.length; i++) {
      let budgetLineItemQuantities: BudgetLineItemQuantities = {
        idLineItem: listBudgetAllLineItem[i].idLineItem,
        referenceLineItem: listBudgetAllLineItem[i].reference,
        idLineItemUser: (listBudgetAllLineItem[i].idLineItemUser == 0 ? null : listBudgetAllLineItem[i].idLineItemUser),
        quantity: listBudgetAllLineItem[i].quantity,
        idChapter: (listBudgetAllLineItem[i].chapterReference?.trim() != '' ? listBudgetAllLineItem[i].idChapterReference : null),
        benefit: listBudgetAllLineItem[i].benefit.toFixed(2),
        administrativeExpense: listBudgetAllLineItem[i].administrativeExpense.toFixed(2),
        unexpectedUtility: listBudgetAllLineItem[i].unexpectedUtility.toFixed(2),
        financing: listBudgetAllLineItem[i].financing.toFixed(2),
        ivaLineItem: listBudgetAllLineItem[i].iva.toFixed(2),
        otherTax: listBudgetAllLineItem[i].otherTax.toFixed(2),
        indexLn: i
      }
      listBudgetLineItemQuantities.push(budgetLineItemQuantities);
    }

    let data = {
      budgetLineItemQuantities: listBudgetLineItemQuantities,
      idBudget: this.infoPresupuesto.budgetId,
      totalPriceBudget: this.budgeTotal,
      iva: this.budgetlIva,
      otherTaxBudget: this.budgetOtherTax
    }

    this.apiCallService.call$(data, this.route, this.method, true, '', true)
      .pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {
          let dataModify: any[] = response.data;
          for (let i = 0; i < dataModify.length; i++) {
            let modify = dataModify[i];
            for (let j = 0; j < listBudgetAllLineItem.length; j++) {
              let dataLineItem = listBudgetAllLineItem[j];
              if (modify.idLineItem == dataLineItem.idLineItem) {
                dataLineItem.idLineItemUser = modify.idLineItemUser;
                this.cachePartidasService.modify(dataLineItem.idLineItem.toString(), dataLineItem);
              }
            }
          }
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_BUDGET_UPDATED_SUCCESS, false, true, false, '', '', '', Constanst.DIALOG_RESULT_SUCCESS);
        } else {
          this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
        }
        this.apiCallService.hideSpinner();
      });
    listBudgetLineItemQuantities = [];
  }

  verResumenPartida(row: BudgetItem) {
    this.xpandStatus = false; this.xpandDisabled = true;
    this.route = ''; this.method = ''; let data = {};

    if (row.idLineItemUser == 0) {
    //Partida no agregada al presupuesto, buscar resumen en tablas originales.
      this.route = '/getLineItem';
      this.method = 'POST';
      data = {
        idLineItem: row.idLineItem
      }
    } else {
      //Partida agregada al presupuesto, buscar resumen en tablas de presupuesto.
      this.route = '/getLineItemUser';
      this.method = 'POST';
      data = {
        idLineItemUser: row.idLineItemUser
      }
    }

    this.apiCallService.call$(data, this.route, this.method, true, '', false)
      .pipe(takeUntil(this.destroy$)).subscribe(
        responseItem => {
          if (responseItem.status === Constanst.RESPONSE_STATUS_SUCCESS) {

            let materialDetailList: any[] = responseItem.data.materialDetailList;
            if (row.idLineItemUser == 0) {
            //Se debe validar y reemplazar precios de materiales.
              if (materialDetailList.length > 0) {
                let materialPriceReplaceList: any[] = [];
                this.cachePartidasService.getOnBudgetById(Constanst.CACHE_MATERIAL_PRICE_REPLACE).subscribe((priceReplaceList: any) => {
                  materialPriceReplaceList = priceReplaceList;
                });

                if (materialPriceReplaceList !== undefined && materialPriceReplaceList.length > 0) {
                  for (let i = 0; i < materialDetailList.length; i++) {
                    for (let j = 0; j < materialPriceReplaceList.length; j++) {
                      if (materialDetailList[i].referenceMaterial == materialPriceReplaceList[j].materialReference) {
                        materialDetailList[i].priceMaterial = materialPriceReplaceList[j].price;
                        //materialDetailList[i].materialQuantity = materialPriceReplaceList[j].materialQuantity;
                        materialDetailList[i].wasteMaterial = materialPriceReplaceList[j].materialDepreciation;
                        let calculo = Number(this.decimalPipe.transform(materialDetailList[i].priceMaterial * materialDetailList[i].materialQuantity, '1.4-4')?.replace(',', '')) * (1 + (materialDetailList[i].wasteMaterial / 100));
                        materialDetailList[i].materialTotalPrice = Number(this.decimalPipe.transform(calculo, '1.2-2')?.replace(',', ''));
                      }
                    }
                  }
                }
              }
            }

            let equipmentDetailList: any[] = responseItem.data.equipmentDetailList;
            if (row.idLineItemUser == 0) {
            //Se debe validar y reemplazar precios de equipos.
              if (equipmentDetailList.length > 0) {
                let equipmentPriceReplaceList: any[] = [];
                this.cachePartidasService.getOnBudgetById(Constanst.CACHE_EQUIPMENT_PRICE_REPLACE).subscribe((priceReplaceList: any) => {
                  equipmentPriceReplaceList = priceReplaceList;
                });

                if (equipmentPriceReplaceList !== undefined && equipmentPriceReplaceList.length > 0) {
                  for (let i = 0; i < equipmentDetailList.length; i++) {
                    for (let j = 0; j < equipmentPriceReplaceList.length; j++) {
                      if (equipmentDetailList[i].equipmentReference == equipmentPriceReplaceList[j].equipmentReference) {
                        equipmentDetailList[i].priceEquipment = equipmentPriceReplaceList[j].equipmentPriceChanged; 
                        //equipmentDetailList[i].quantityEquipment = equipmentPriceReplaceList[j].equipmentQuantity;
                        equipmentDetailList[i].depreciationEquipment = equipmentPriceReplaceList[j].equipmentDepreciation;
                        equipmentDetailList[i].equipmentTotalPrice = Number(this.decimalPipe.transform(equipmentDetailList[i].priceEquipment * equipmentDetailList[i].depreciationEquipment, '1.6-6')?.replace(',', '')) * (Number(this.decimalPipe.transform(equipmentDetailList[i].quantityEquipment, '1.2-2')?.replace(',', '')));
                      }
                    }
                  }
                }
              }
            }

            let laborDetailList: any[] = responseItem.data.laborDetailList;
            if (row.idLineItemUser == 0) {
            //Se debe validar y reemplazar precios de mano de obra.
              if (laborDetailList.length > 0) {
                let laborPriceReplaceList: any[] = [];
                this.cachePartidasService.getOnBudgetById(Constanst.CACHE_LABOR_PRICE_REPLACE).subscribe((priceReplaceList: any) => {
                  laborPriceReplaceList = priceReplaceList;
                });

                if (laborPriceReplaceList !== undefined && laborPriceReplaceList.length > 0) {
                  for (let i = 0; i < laborDetailList.length; i++) {
                    for (let j = 0; j < laborPriceReplaceList.length; j++) {
                      if (laborDetailList[i].laborReference == laborPriceReplaceList[j].laborReference) {
                        laborDetailList[i].priceLabor = laborPriceReplaceList[j].laborPriceChange;
                        //laborDetailList[i].quantityLabor = laborPriceReplaceList[j].quantityLabor;
                        laborDetailList[i].jornalLabor = laborPriceReplaceList[j].jornalLabor;
                        laborDetailList[i].laborTotalBonus = Number(this.decimalPipe.transform(laborDetailList[i].quantityLabor * laborDetailList[i].priceLabor, '1.2-2')?.replace(',', ''));
                      }
                    }
                  }
                }
              }
            }

            this.dataSourceMaterial.data = materialDetailList;
            this.dataSourceEquipo.data = equipmentDetailList;
            this.dataSourceManosObra.data = laborDetailList;

            //Calculo de Totales
            this.totalMateriales = materialDetailList.map((t: { materialTotalPrice: any; }) => t.materialTotalPrice).reduce((acc: number, value: number) => acc + value, 0);
            this.totalEquipos = equipmentDetailList.map((t: { equipmentTotalPrice: any; }) => t.equipmentTotalPrice).reduce((acc: number, value: number) => acc + value, 0);
            this.totalManoDeObra = laborDetailList.map((t: { laborTotalJornal: any; }) => t.laborTotalJornal).reduce((acc: number, value: number) => acc + value, 0);
            this.totalBonoManoDeObra = laborDetailList.map((t: { laborTotalBonus: any; }) => t.laborTotalBonus).reduce((acc: number, value: number) => acc + value, 0);
            this.apuConditionId = responseItem.data.idApuCondition;

            this.rendimiento = responseItem.data.normalPerformance;
            this.workingHour = 8;

            //Seteando Porcentajes
            this.porcFinanciamiento = row.financing;
            this.porcGastosAdministrativos = row.administrativeExpense;
            this.porcImpuestoIva = row.iva;
            this.porcOtrosImpuestos = row.otherTax;
            this.porcUtilidadesImprevisto = row.unexpectedUtility;
            this.porcPrestacionesManoDeObra = row.benefit;

            //Calculo Materiales
            this.costoUnicoMateriales = this.totalMateriales;

            //Calculo Costo Unico Equipos
            this.costoUnicoEquipo = this.totalEquipos / this.rendimiento;

            //Calculos Mano de Obra
            this.prestManoDeObra = (this.porcPrestacionesManoDeObra / 100) * Number(this.decimalPipe.transform(this.totalManoDeObra, '1.2')?.replace(',', ''));
            this.totalGeneralManoDeObra = this.totalManoDeObra + this.totalBonoManoDeObra + this.prestManoDeObra;
            let totalGeneralManoDeObraTrans = (this.decimalPipe.transform(this.totalGeneralManoDeObra, '1.2-2'))?.replace(',', '');
            this.costoUnicoManoDeObra = Number(totalGeneralManoDeObraTrans) / this.rendimiento;

            let costoUnicoManoDeObraRounded = (this.decimalPipe.transform(this.costoUnicoManoDeObra, '1.2-2'))?.replace(',', '');
            let costoUnicoEquipoRounded = (this.decimalPipe.transform(this.costoUnicoEquipo, '1.2-2'))?.replace(',', '');
            let costoUnicoMaterialesRounded = (this.decimalPipe.transform(this.costoUnicoMateriales, '1.2-2'))?.replace(',', '');

            //Calculos Partida
            this.costoDirectoSubTotalA = (Number(costoUnicoMaterialesRounded) + Number(costoUnicoEquipoRounded) + Number(costoUnicoManoDeObraRounded));
            let costoDirectoSubTotalARounded = (this.decimalPipe.transform(this.costoDirectoSubTotalA, '1.2-2'))?.replace(',', '');
            this.gastosGeneralesAdmin = Number(costoDirectoSubTotalARounded) * (this.porcGastosAdministrativos / 100);
            let gastosGeneralesAdminRounded = (this.decimalPipe.transform(this.gastosGeneralesAdmin, '1.2-2'))?.replace(',', '');
            this.subTotalB = (Number(costoDirectoSubTotalARounded)) + (Number(gastosGeneralesAdminRounded));
            let subTotalBRounded = (this.decimalPipe.transform(this.subTotalB, '1.2-2'))?.replace(',', '');
            this.utilidadesImprevisto = Number(subTotalBRounded) * (this.porcUtilidadesImprevisto / 100);
            this.subTotalC = Number(subTotalBRounded) + this.utilidadesImprevisto;
            this.financiamiento = this.subTotalC * (this.porcFinanciamiento / 100);
            this.precioUnitarioSinImpuesto = this.subTotalC + this.financiamiento;
            this.montoImpuestoIva = (this.infoPresupuesto.applyIva == Constanst.APLICAR_IVA_APU ? (this.precioUnitarioSinImpuesto * (this.porcImpuestoIva / 100)) : 0);
            this.montoOtrosImpuestos = (this.infoPresupuesto.applyIva == Constanst.APLICAR_IVA_APU ? (this.precioUnitarioSinImpuesto * (this.porcOtrosImpuestos / 100)) : 0);
            this.precioUnitario = this.precioUnitarioSinImpuesto + this.montoImpuestoIva + this.montoOtrosImpuestos;

            //Calculo % de incidencias
            this.porcIncidenciasMateriales = (Number(costoUnicoMaterialesRounded) / (Number(costoDirectoSubTotalARounded))) * 100;
            this.porcIncidenciasEquipos = (Number(costoUnicoEquipoRounded) / (Number(costoDirectoSubTotalARounded))) * 100;
            this.porcIncidenciasManoDeObra = (Number(costoUnicoManoDeObraRounded) / (Number(costoDirectoSubTotalARounded))) * 100;

            this.totalTrabajadores = laborDetailList.map((t: { quantityLabor: any; }) => t.quantityLabor).reduce((acc: number, value: number) => acc + value, 0);
            this.workingHourDay = this.totalTrabajadores * this.workingHour;

            this.referenciaPartida = row.reference;
            this.descripcionPartidaPanel = row.description
            this.xpandDisabled = false;
          } else {
            this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
          }
          this.apiCallService.hideSpinner();
        }
      );
  }

  async generarExcelPresupuesto(exporEscritorio: boolean) {
    if (this.dataSourceFilters.data.length > 0) {
      let dialogConfirmSavedBudget = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_CONFIRM_SAVED_BUDGET, true, true, false, Constanst.DIALOG_ACTIONBTCANCEL, Constanst.DIALOG_ACTIONBTACCEPT, '', Constanst.DIALOG_RESULT_INFO);
      dialogConfirmSavedBudget.afterClosed().subscribe(async (result: string) => {
        if (result === Constanst.DIALOG_RESULT_ACTION) {

          this.route = '/updateBudgetNew';
          this.method = 'POST';
          let listBudgetLineItemQuantities: BudgetLineItemQuantities[] = [];
          let listBudgetAllLineItem: BudgetItem[] = [];
          this.cachePartidasService.getAll().subscribe((dataBudgetItem: BudgetItem[]) => {
            listBudgetAllLineItem = dataBudgetItem;
          });

          for (let i = 0; i < listBudgetAllLineItem.length; i++) {
            let budgetLineItemQuantities: BudgetLineItemQuantities = {
              idLineItem: listBudgetAllLineItem[i].idLineItem,
              referenceLineItem: listBudgetAllLineItem[i].reference,
              idLineItemUser: (listBudgetAllLineItem[i].idLineItemUser == 0 ? null : listBudgetAllLineItem[i].idLineItemUser),
              quantity: listBudgetAllLineItem[i].quantity,
              idChapter: (listBudgetAllLineItem[i].chapterReference?.trim() != '' ? listBudgetAllLineItem[i].idChapterReference : null),
              benefit: listBudgetAllLineItem[i].benefit.toFixed(2),
              administrativeExpense: listBudgetAllLineItem[i].administrativeExpense.toFixed(2),
              unexpectedUtility: listBudgetAllLineItem[i].unexpectedUtility.toFixed(2),
              financing: listBudgetAllLineItem[i].financing.toFixed(2),
              ivaLineItem: listBudgetAllLineItem[i].iva.toFixed(2),
              otherTax: listBudgetAllLineItem[i].otherTax.toFixed(2),
              indexLn: i
            }
            listBudgetLineItemQuantities.push(budgetLineItemQuantities);
          }

          let dataUpdate = {
            budgetLineItemQuantities: listBudgetLineItemQuantities,
            idBudget: this.infoPresupuesto.budgetId,
            totalPriceBudget: this.budgeTotal,
            iva: this.budgetlIva,
            otherTaxBudget: this.budgetOtherTax
          }

          this.apiCallService.call$(dataUpdate, this.route, this.method, true, '', true)
            .pipe(takeUntil(this.destroy$)).subscribe(async responseUpdate => {
              if (responseUpdate.status === Constanst.RESPONSE_STATUS_SUCCESS) {

                let dataModify: any[] = responseUpdate.data;
                for (let i = 0; i < dataModify.length; i++) {
                  let modify = dataModify[i];
                  for (let j = 0; j < listBudgetAllLineItem.length; j++) {
                    let dataLineItem = listBudgetAllLineItem[j];
                    if (modify.idLineItem == dataLineItem.idLineItem) {
                      dataLineItem.idLineItemUser = modify.idLineItemUser;
                      this.cachePartidasService.modify(dataLineItem.idLineItem.toString(), dataLineItem);
                    }
                  }
                }

                this.disableExcel = true;
                let listPartidasPresupuesto: any[] = [], capitulosSinRepetir: string[] = [];
                let listMaterialesPresupuesto: any[] = [], listEquiposPresupuesto: any[] = [], listManoObraPresupuesto: any[] = [];
                let loadedAllApu: boolean = true;

                this.route = '/getMaterialByBudgetLineItem';
                this.method = 'POST';
                let data = {
                  idBudget: this.infoPresupuesto.budgetId
                }
                let materialByBudget$ = this.apiCallService.call$(data, this.route, this.method, true, '', true);
                let responseMaterial = await lastValueFrom(materialByBudget$);

                if (responseMaterial.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                  if (responseMaterial.data.length > 0) {
                    let responseMaterialesPresupuesto: any[] = responseMaterial.data;
                    responseMaterialesPresupuesto.sort((a, b) => a.materialCode.localeCompare(b.materialCode));
                    for (let [i, material] of responseMaterialesPresupuesto.entries()) {
                      let materialBudget = {
                        columA: '',
                        materialCode: material.materialCode,
                        materialDescription: material.materialDescription,
                        unitDescription: material.unitDescription,
                        price: material.price,
                        ratio: material.ratio,
                        materialFamilyName: material.materialFamilyName,
                        proveMaterial: (material.supplierName ? material.supplierName : '')
                      };
                      listMaterialesPresupuesto.push(materialBudget);
                    }
                  }
                } else {
                  this.apiCallService.hideSpinner();
                  this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
                }

                this.route = '/getEquipmenstByBudgetLineItem';
                let equipmenstBudget$ = this.apiCallService.call$(data, this.route, this.method, true, '', true);
                let responseEquipmenst = await lastValueFrom(equipmenstBudget$);

                if (responseEquipmenst.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                  if (responseEquipmenst.data.length > 0) {
                    let responseEquiposPresupuesto: any[] = responseEquipmenst.data;
                    responseEquiposPresupuesto.sort((a, b) => a.reference.localeCompare(b.reference));
                    for (let [i, equipo] of responseEquiposPresupuesto.entries()) {
                      let equipmentBudget = {
                        columA: '',
                        reference: equipo.reference,
                        descriptionLabor: equipo.descriptionLabor,
                        priceEquipment: equipo.priceEquipment,
                        copDep: equipo.copDep,
                        supplierName: (equipo.supplierName ? equipo.supplierName : '')
                      };
                      listEquiposPresupuesto.push(equipmentBudget);
                    }
                  }
                } else {
                  this.apiCallService.hideSpinner();
                  this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
                }

                this.route = '/getLaborByBudgetLineItem';
                let laborsBudget$ = this.apiCallService.call$(data, this.route, this.method, true, '', true);
                let responseLabors = await lastValueFrom(laborsBudget$);

                if (responseLabors.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                  if (responseLabors.data.length > 0) {
                    let responseManoObraPresupuesto: any[] = responseLabors.data;
                    responseManoObraPresupuesto.sort((a, b) => a.reference.localeCompare(b.reference));
                    for (let [i, labor] of responseManoObraPresupuesto.entries()) {
                      let laborBudget = {
                        columA: '',
                        reference: labor.reference,
                        descriptionLabor: labor.descriptionLabor,
                        jornalBs: labor.jornalBs,
                        bonusBs: labor.bonusBs,
                        groupLabor: labor.groupLabor
                      };
                      listManoObraPresupuesto.push(laborBudget);
                    }
                  }
                } else {
                  this.apiCallService.hideSpinner();
                  this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
                }

                this.dataSourceFilters.data.sort((a, b) => a.reference.localeCompare(b.chapterReference!));
                for await (let [index, lineItem] of this.dataSourceFilters.data.entries()) {
                  let data = {};
                  if (lineItem.idLineItemUser == 0) {
                    this.route = '/getLineItem';
                    this.method = 'POST';
                    data = {
                      idLineItem: lineItem.idLineItem
                    }
                  } else {
                    this.route = '/getLineItemUser';
                    this.method = 'POST';
                    data = {
                      idLineItemUser: lineItem.idLineItemUser
                    }
                  }

                  let roleTypes$ = this.apiCallService.call$(data, this.route, this.method, true, '', true);
                  let responseItem = await lastValueFrom(roleTypes$);

                  if (responseItem.status === Constanst.RESPONSE_STATUS_SUCCESS) {

                    let materialDetailList: any[] = responseItem.data.materialDetailList;
                    if (lineItem.idLineItemUser == 0) {
                      if (materialDetailList.length > 0) {
                        let materialPriceReplaceList: any[] = [];
                        this.cachePartidasService.getOnBudgetById(Constanst.CACHE_MATERIAL_PRICE_REPLACE).subscribe((priceReplaceList: any) => {
                          materialPriceReplaceList = priceReplaceList;
                        });

                        if (materialPriceReplaceList !== undefined && materialPriceReplaceList.length > 0) {
                          for (let i = 0; i < materialDetailList.length; i++) {
                            for (let j = 0; j < materialPriceReplaceList.length; j++) {
                              if (materialDetailList[i].referenceMaterial == materialPriceReplaceList[j].materialReference) {
                                materialDetailList[i].priceMaterial = materialPriceReplaceList[j].price;
                                //materialDetailList[i].materialQuantity = materialPriceReplaceList[j].materialQuantity;
                                materialDetailList[i].wasteMaterial = materialPriceReplaceList[j].materialDepreciation;
                                let calculo = Number(this.decimalPipe.transform(materialDetailList[i].priceMaterial * materialDetailList[i].materialQuantity, '1.4-4')?.replace(',', '')) * (1 + (materialDetailList[i].wasteMaterial / 100));
                                materialDetailList[i].materialTotalPrice = Number(this.decimalPipe.transform(calculo, '1.2-2')?.replace(',', ''));
                              }
                            }
                          }
                        }
                      }
                    }

                    let equipmentDetailList: any[] = responseItem.data.equipmentDetailList;
                    if (lineItem.idLineItemUser == 0) {
                      if (equipmentDetailList.length > 0) {
                        let equipmentPriceReplaceList: any[] = [];
                        this.cachePartidasService.getOnBudgetById(Constanst.CACHE_EQUIPMENT_PRICE_REPLACE).subscribe((priceReplaceList: any) => {
                          equipmentPriceReplaceList = priceReplaceList;
                        });

                        if (equipmentPriceReplaceList !== undefined && equipmentPriceReplaceList.length > 0) {
                          for (let i = 0; i < equipmentDetailList.length; i++) {
                            for (let j = 0; j < equipmentPriceReplaceList.length; j++) {
                              if (equipmentDetailList[i].equipmentReference == equipmentPriceReplaceList[j].equipmentReference) {
                                equipmentDetailList[i].priceEquipment = equipmentPriceReplaceList[j].equipmentPriceChanged;
                                //equipmentDetailList[i].quantityEquipment = equipmentPriceReplaceList[j].equipmentQuantity;
                                equipmentDetailList[i].depreciationEquipment = equipmentPriceReplaceList[j].equipmentDepreciation;
                                equipmentDetailList[i].equipmentTotalPrice = Number(this.decimalPipe.transform(equipmentDetailList[i].priceEquipment * equipmentDetailList[i].depreciationEquipment, '1.6-6')?.replace(',', '')) * (Number(this.decimalPipe.transform(equipmentDetailList[i].quantityEquipment, '1.2-2')?.replace(',', '')));
                              }
                            }
                          }
                        }
                      }
                    }

                    let laborDetailList: any[] = responseItem.data.laborDetailList;
                    if (lineItem.idLineItemUser == 0) {
                      if (laborDetailList.length > 0) {
                        let laborPriceReplaceList: any[] = [];
                        this.cachePartidasService.getOnBudgetById(Constanst.CACHE_LABOR_PRICE_REPLACE).subscribe((priceReplaceList: any) => {
                          laborPriceReplaceList = priceReplaceList;
                        });

                        if (laborPriceReplaceList !== undefined && laborPriceReplaceList.length > 0) {
                          for (let i = 0; i < laborDetailList.length; i++) {
                            for (let j = 0; j < laborPriceReplaceList.length; j++) {
                              if (laborDetailList[i].laborReference == laborPriceReplaceList[j].laborReference) {
                                laborDetailList[i].priceLabor = laborPriceReplaceList[j].laborPriceChange;
                                //laborDetailList[i].quantityLabor = laborPriceReplaceList[j].quantityLabor;
                                laborDetailList[i].jornalLabor = laborPriceReplaceList[j].jornalLabor;
                                laborDetailList[i].laborTotalBonus = Number(this.decimalPipe.transform(laborDetailList[i].quantityLabor * laborDetailList[i].priceLabor, '1.2-2')?.replace(',', ''));
                              }
                            }
                          }
                        }
                      }
                    }

                    //Calculo de Totales
                    let totalMateriales = materialDetailList.map((t: { materialTotalPrice: any; }) => t.materialTotalPrice).reduce((acc: number, value: number) => acc + value, 0);
                    let totalEquipos = equipmentDetailList.map((t: { equipmentTotalPrice: any; }) => t.equipmentTotalPrice).reduce((acc: number, value: number) => acc + value, 0);
                    let totalManoDeObra = laborDetailList.map((t: { laborTotalJornal: any; }) => t.laborTotalJornal).reduce((acc: number, value: number) => acc + value, 0);
                    let totalBonoManoDeObra = laborDetailList.map((t: { laborTotalBonus: any; }) => t.laborTotalBonus).reduce((acc: number, value: number) => acc + value, 0);
                    let rendimiento = responseItem.data.normalPerformance;
                    //Seteando Porcentajes
                    let porcFinanciamiento = lineItem.financing;
                    let porcGastosAdministrativos = lineItem.administrativeExpense;
                    let porcImpuestoIva = lineItem.iva;
                    let porcOtrosImpuestos = lineItem.otherTax;
                    let porcUtilidadesImprevisto = lineItem.unexpectedUtility;
                    let porcPrestacionesManoDeObra = lineItem.benefit;
                    //Calculo Materiales
                    let costoUnicoMateriales = totalMateriales;
                    //Calculo Costo Unico Equipos
                    let costoUnicoEquipo = totalEquipos / rendimiento;
                    //Calculos Mano de Obra
                    let prestManoDeObra = (porcPrestacionesManoDeObra / 100) * Number(this.decimalPipe.transform(totalManoDeObra, '1.2'));
                    let totalGeneralManoDeObra = totalManoDeObra + totalBonoManoDeObra + prestManoDeObra;
                    let totalGeneralManoDeObraTrans = (this.decimalPipe.transform(totalGeneralManoDeObra, '1.2-2'))?.replace(',', '');
                    let costoUnicoManoDeObra = Number(totalGeneralManoDeObraTrans) / rendimiento;
                    //Calculos Partida
                    let costoDirectoSubTotalA = totalMateriales + costoUnicoEquipo + costoUnicoManoDeObra;
                    let costoDirectoSubTotalARounded = (this.decimalPipe.transform(costoDirectoSubTotalA, '1.2-2'))?.replace(',', '');
                    let gastosGeneralesAdmin = Number(costoDirectoSubTotalARounded) * (porcGastosAdministrativos / 100);
                    let subTotalB = (Number(costoDirectoSubTotalARounded)) + gastosGeneralesAdmin;
                    let subTotalBRounded = (this.decimalPipe.transform(subTotalB, '1.2-2'))?.replace(',', '');
                    let utilidadesImprevisto = (Number(subTotalBRounded) * porcUtilidadesImprevisto) / 100;
                    let subTotalC = (Number(subTotalBRounded)) + utilidadesImprevisto;
                    let financiamiento = (subTotalC * porcFinanciamiento) / 100;
                    let precioUnitarioSinImpuesto = subTotalC + financiamiento;
                    let montoImpuestoIva = (this.infoPresupuesto.applyIva == Constanst.APLICAR_IVA_APU ? (precioUnitarioSinImpuesto * (porcImpuestoIva / 100)) : 0);
                    let montoOtrosImpuestos = (this.infoPresupuesto.applyIva == Constanst.APLICAR_IVA_APU ? (precioUnitarioSinImpuesto * (porcOtrosImpuestos / 100)) : 0);
                    let precioUnitario = precioUnitarioSinImpuesto + montoImpuestoIva + montoOtrosImpuestos;
                    let tipoCapituloActual = (lineItem.chapterReference != null && lineItem.chapterReference.trim() != '' ? lineItem.descriptionChapter!.trim() : Constanst.CHAPTER_DESCRIPTION_EMPTY);
                    let partidasPresupuesto = {
                      reference: responseItem.data.reference,
                      code: responseItem.data.code,
                      description: responseItem.data.description,
                      updateDate: this.datePipe.transform(responseItem.data.updateDate, 'dd/MM/yyyy'),
                      lowPerformance: responseItem.data.normalPerformance,
                      unit: responseItem.data.unit,
                      quantity: lineItem.quantity,
                      desCapitulo: tipoCapituloActual,
                      materialDetailList: materialDetailList,
                      equipmentDetailList: equipmentDetailList,
                      laborDetailList: laborDetailList,
                      porcFinanciamiento: lineItem.financing,
                      porcGastosAdministrativos: lineItem.administrativeExpense,
                      porcImpuestoIva: lineItem.iva,
                      porcOtrosImpuestos: lineItem.otherTax,
                      porcUtilidadesImprevisto: lineItem.unexpectedUtility,
                      porcPrestacionesManoDeObra: lineItem.benefit,
                      precioUnitario: precioUnitario
                    };
                    listPartidasPresupuesto.push(partidasPresupuesto);

                    if (!capitulosSinRepetir.includes(tipoCapituloActual)) {
                      capitulosSinRepetir.push(tipoCapituloActual);
                    }

                  } else {
                    loadedAllApu = false;
                    break;
                  }
                }

                if (loadedAllApu) {
                  capitulosSinRepetir = capitulosSinRepetir.sort((a, b) => a.localeCompare(b));

                  let reportPresupuestoData = {
                    titleReport: Constanst.EXCEL_REPORT_NAME_BUDGET,
                    nombre: this.infoPresupuesto.budgetName,
                    contratante: this.infoPresupuesto.contractor,
                    compania: this.infoPresupuesto.companyBudget,
                    ubicacion: this.infoPresupuesto.location,
                    porcIva: this.budgetlIva,
                    aplicaIva: this.infoPresupuesto.applyIva,
                    porcOtrosImp: this.budgetOtherTax,
                    dataMateriales: listMaterialesPresupuesto,
                    dataEquipos: listEquiposPresupuesto,
                    dataManoObras: listManoObraPresupuesto,
                    dataPartidas: listPartidasPresupuesto,
                    formatoEscritorio: exporEscritorio,
                    capitulosPartida: capitulosSinRepetir,
                  }
                  this.exportExcelService.exportExcelPresupuesto(reportPresupuestoData);
                } else {
                  this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_ERROR_LINEITEM_BUDGET, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
                  this.apiCallService.hideSpinner();
                }
              } else {
                this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
                this.apiCallService.hideSpinner();
              }
            });
        } else {
          dialogConfirmSavedBudget.close(false);
        }
      });
    } else {
      this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_EMPTY_BUDGET, false, true, false, '', '', '', Constanst.DIALOG_RESULT_INFO);
    }
  }

  closeExpansionPanel() {
    this.xpandStatus = false;
  }

  async reloadBudgetDetail() {
    let localBudget = localStorage.getItem(Constanst.STORAGE_DATA_BUDGETSELECT);
    let pBudget = JSON.parse(localBudget!);
    this.route = '/getAllBudgetLineItemByBudget';
    this.method = 'POST';
    let data = {
      idBudget: pBudget.idBudget
    };
    let dataBudget$ = this.apiCallService.call$(data, this.route, this.method, true, '', true);
    let response = await lastValueFrom(dataBudget$);

    if (response.status === Constanst.RESPONSE_STATUS_SUCCESS) {

      response.data = response.data.reverse();
      for (let i = 0; i < response.data.length; i++) {
        let partida: BudgetItem = {
          position: (i + 1),
          chapterReference: (response.data[i].referenceChapter != null ? response.data[i].referenceChapter : ''),
          reference: response.data[i].referenceBudgetLineItem,
          code: response.data[i].codeBudgetLineItem,
          description: response.data[i].descriptionBudgetLineItem,
          unit: response.data[i].unitName,
          quantity: response.data[i].lineItemQuantity,
          unitPrice: response.data[i].calculatedUnitPrice,
          assumedPrice: response.data[i].assumedPrice,
          total: (response.data[i].calculatedUnitPrice * response.data[i].lineItemQuantity),
          performance: response.data[i].performance,
          idLineItem: response.data[i].idLineItem,
          lineItemGrouping: response.data[i].groupingDescription,
          idBudgetLineItem: response.data[i].idBudgetLineItem,
          idChapterReference: (response.data[i].idChapter != null ? response.data[i].idChapter : null),
          descriptionChapter: (response.data[i].descriptionChapter != null ? response.data[i].descriptionChapter : ''),
          benefit: response.data[i].benefit,
          administrativeExpense: response.data[i].administrativeExpense,
          unexpectedUtility: response.data[i].unexpectedUtility,
          financing: response.data[i].financing,
          iva: response.data[i].iva,
          otherTax: response.data[i].otherTax,
          idLineItemUser: response.data[i].idLineItemUser
        }
        this.cachePartidasService.save(partida.idLineItem.toString(), partida);
      }

      let applyIva: number = pBudget.applyIva;
      let tipoIva: string = '';
      if (applyIva == 1) { tipoIva = Constanst.APLICAR_IVA_PRESUPUESTO };
      if (applyIva == 2) { tipoIva = Constanst.APLICAR_IVA_APU };
      if (applyIva == 3) { tipoIva = Constanst.APLICAR_IVA_NINGUNO };

      let detallePresupuesto: BudgetDetails = {
        budgetId: pBudget.idBudget,
        budgetName: pBudget.titleWork.toUpperCase(),
        contractor: pBudget.contractor,
        applyIva: tipoIva,
        companyBudget: pBudget.companyBudget,
        location: pBudget.location,
        signatures: pBudget.signatures
      };

      this.infoPresupuesto = detallePresupuesto;
      this.budgetName = this.infoPresupuesto.budgetName;
      this.cachePartidasService.saveOnBudget(Constanst.CACHE_NAME_BUDGET_IVA, pBudget.iva);
      this.budgetlIva = pBudget.iva;
      this.cachePartidasService.saveOnBudget(Constanst.CACHE_NAME_BUDGET_OTHERTAX, pBudget.otherTax);
      this.budgetOtherTax = pBudget.otherTax;
      this.processBudgetTotals();
      this.apiCallService.hideSpinner();
    } else {
      this.apiCallService.hideSpinner();
      this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
    }
  }
}
